import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { ModalFilterData } from '../../model/modal-filter';

@Component({
  template: '',
})
export class UsfFilteringOptionComponent<T extends ModalFilterData, U> {
  @Input() isTouch: boolean;
  @Input() data: T;
  @Output() optionSelected = new EventEmitter<U>();

  constructor(public ionNav: IonNav) {}

  navigateBack() {
    this.ionNav.pop();
  }
}
